import {Component, EventEmitter, Input, Output} from '@angular/core';

import {KeyPoint} from 'shared/models/questions/keypoint';
import {PerformanceLevelQuestionType} from 'shared/models/questions/performance-level-question-type';
import {TranslatedText} from 'shared/models/translated-text';
import {TypeSliderComponent} from '../type-slider/type-slider.component';

@Component({
  selector: 'type-performancelevel',
  templateUrl: './type-performancelevel.component.html',
  styleUrls: ['./type-performancelevel.component.css'],
})
export class TypePerformancelevelComponent {

  @Input() public language: string;
  @Input() public data: PerformanceLevelQuestionType;
  @Input() public inChains: Array<string>;
  @Input() public isSystemQuestion: boolean;
  @Input() public isChainSystemEditable: boolean = false;
  @Output() public dataChange: EventEmitter<PerformanceLevelQuestionType>;

  public oldKeyPointCount: number = null;

  constructor() {
    this.data = new PerformanceLevelQuestionType();
    this.dataChange = new EventEmitter<PerformanceLevelQuestionType>();
  }

  public addKeyPoint(): void {
    if (this.oldKeyPointCount === null) {
      this.oldKeyPointCount = this.data.keyPoints.length;
    }
    this.data.addKeyPoint();
    this.dataChange.emit(this.data);
  }

  public deleteKeyPoint(index: number): void {
    this.data.deleteKeyPoint(index);
    this.dataChange.emit(this.data);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-performancelevel/type-performancelevel.component.ts